/**
 * FooterLogo Component
 * Displays the abstract logo at the top of the footer
 */
import React from 'react';
import './FooterLogo.css';

const FooterLogo = () => {
  return (
    <div className="footer-abstract-logo">
      <img src="/logos/final-logo-128.svg" alt="Abstract Logo" />
    </div>
  );
};

export default FooterLogo;

